// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".open-trace-button-openTraceButton-ad669{display:inline-block}.open-trace-button-openTraceButton-ad669 .open-trace-button-edit-wrapper-56202{align-items:center;display:flex;margin-bottom:12px}.open-trace-button-openTraceButton-ad669 .open-trace-button-edit-wrapper-56202 .open-trace-button-title-7a12c{font-size:12px;font-weight:500;margin-right:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"openTraceButton": "open-trace-button-openTraceButton-ad669",
	"edit-wrapper": "open-trace-button-edit-wrapper-56202",
	"editWrapper": "open-trace-button-edit-wrapper-56202",
	"title": "open-trace-button-title-7a12c"
};
export default ___CSS_LOADER_EXPORT___;
